import request from '@/utils/request'

// ==================== 机构 CRUD ====================

// 分页查询机构列表
export function getOrgList(params) {
  return request({ url: '/admin/org/list', method: 'get', params })
}

// 获取机构详情（编辑回显）
export function getOrgDetail(id) {
  return request({ url: `/admin/org/${id}`, method: 'get' })
}

// 新增机构
export function createOrg(data) {
  return request({ url: '/admin/org/create', method: 'post', data })
}

// 编辑机构
export function updateOrg(id, data) {
  return request({ url: `/admin/org/${id}`, method: 'put', data })
}

// 逻辑删除机构
export function deleteOrg(id) {
  return request({ url: `/admin/org/${id}`, method: 'delete' })
}

// 删除前关联数据预览
export function getOrgDeletePreview(id) {
  return request({ url: `/admin/org/${id}/delete-preview`, method: 'get' })
}

// ==================== 唯一性校验 ====================

// 校验机构名称唯一性
export function checkOrgName(params) {
  return request({ url: '/admin/org/check-name', method: 'get', params })
}

// 校验机构编码唯一性
export function checkOrgCode(params) {
  return request({ url: '/admin/org/check-code', method: 'get', params })
}

// ==================== IP 范围配置 ====================

// 查询机构 IP 段列表
export function getIpRangeList(orgId) {
  return request({ url: `/admin/org/${orgId}/ip-range`, method: 'get' })
}

// 新增 IP 段
export function addIpRange(orgId, data) {
  return request({ url: `/admin/org/${orgId}/ip-range`, method: 'post', data })
}

// 编辑 IP 段
export function updateIpRange(id, data) {
  return request({ url: `/admin/org/ip-range/${id}`, method: 'put', data })
}

// 删除 IP 段
export function deleteIpRange(id) {
  return request({ url: `/admin/org/ip-range/${id}`, method: 'delete' })
}

// 获取 IP 登录限制开关状态
export function getIpRestrictStatus(orgId) {
  return request({ url: `/admin/org/${orgId}/ip-restrict`, method: 'get' })
}

// 切换 IP 登录限制开关
export function updateIpRestrict(orgId, data) {
  return request({ url: `/admin/org/${orgId}/ip-restrict`, method: 'put', data })
}

// ==================== 关键词反选配置 ====================

// 查询关键词列表
export function getKeywordFilterList(orgId) {
  return request({ url: `/admin/org/${orgId}/keyword-filter`, method: 'get' })
}

// 新增关键词规则
export function addKeywordFilter(orgId, data) {
  return request({ url: `/admin/org/${orgId}/keyword-filter`, method: 'post', data })
}

// 编辑关键词规则
export function updateKeywordFilter(id, data) {
  return request({ url: `/admin/org/keyword-filter/${id}`, method: 'put', data })
}

// 启用/停用关键词
export function toggleKeywordFilter(id, data) {
  return request({ url: `/admin/org/keyword-filter/${id}/toggle`, method: 'put', data })
}

// 删除关键词
export function deleteKeywordFilter(id) {
  return request({ url: `/admin/org/keyword-filter/${id}`, method: 'delete' })
}

// ==================== 荐购权重配置 ====================

// 获取权重配置（出版社系数 + 学科系数 + 身份类型列表）
export function getWeightConfig(orgId) {
  return request({ url: `/admin/org/${orgId}/weight`, method: 'get' })
}

// 保存权重配置（出版社/学科系数 + 身份类型全量列表，触发异步重算）
export function saveWeightConfig(orgId, data) {
  return request({ url: `/admin/org/${orgId}/weight`, method: 'put', data })
}

// ==================== 首页展示位 ====================

// 获取全部展示位（按类型分组）
export function getHomepageSlots() {
  return request({ url: '/admin/org/homepage-slot', method: 'get' })
}

// 加入展示位
export function addHomepageSlot(data) {
  return request({ url: '/admin/org/homepage-slot', method: 'post', data })
}

// 取消展示位
export function removeHomepageSlot(orgId) {
  return request({ url: `/admin/org/homepage-slot/${orgId}`, method: 'delete' })
}

// 调整展示位排序
export function reorderHomepageSlot(data) {
  return request({ url: '/admin/org/homepage-slot/reorder', method: 'put', data })
}

// ==================== 操作日志 ====================

// 查询机构操作日志（分页）
export function getOrgOperationLogs(orgId, params) {
  return request({ url: `/admin/org/${orgId}/operation-logs`, method: 'get', params })
}

// ==================== LOGO 上传 ====================

// 上传机构 LOGO
export function uploadLogo(data) {
  return request({ url: '/admin/org/upload-logo', method: 'post', data, headers: { 'Content-Type': 'multipart/form-data' } })
}
